import { useTranslation } from "react-i18next";

export const useStartYourFreeTrialModel = () => {
  const { t } = useTranslation();
  return { t };
};

